import * as Plotly from "plotly.js/dist/plotly-custom.min.js";
import locale from "plotly.js-locales/fr";

const structureOutcomesChartInit = () => {
  const wrapper = document.querySelector(".js-structure-outcomes");
  if (!wrapper) return;

  const chart = wrapper.querySelector(".js-structure-outcomes__chart");
  if (!chart) return;

  let config = {
    displayModeBar: false,
  };
  if (document.documentElement.lang == "fr-CA") {
    Plotly.register(locale);
    config.locale = "fr";
  }
  Plotly.setPlotConfig(config);

  const options = wrapper.querySelector(".js-structure-outcomes__options");
  const optionRadios = options.querySelectorAll('input[type="radio"]');
  const activeOption = options.querySelector(
    'input[type="radio"]:checked'
  ).value;
  const endDateSpan = wrapper.querySelector(".js-structure-outcomes__end-date");

  const layout = {
    showlegend: true,
    legend: {
      orientation: "h",
    },
    height: 500,
    xaxis: {
      tickformat: "%B %Y",
    },
    yaxis: {
      tickformat: ".0%",
      zeroline: false,
    },
    paper_bgcolor: "rgba(0, 0, 0, 0)",
    locale: document.documentElement.lang == "fr-CA" ? "fr" : "en",
    dragmode: false,
  };

  let prev = null;
  for (let i = 0; i < optionRadios.length; i++) {
    optionRadios[i].addEventListener("click", function () {
      if (this === prev) return;
      const data = structureOutcomesChartData(this.value, chart, endDateSpan);
      Plotly.react(chart, data, layout);
      prev = this;
    });
  }

  if (activeOption && chart) {
    const data = structureOutcomesChartData(activeOption, chart, endDateSpan);
    Plotly.newPlot(chart, data, layout);
  }
};

const structureOutcomesChartData = (
  activeOption = null,
  chart = null,
  endDateSpan = null
) => {
  let monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (document.documentElement.lang == "fr-CA") {
    monthNames = [
      "jan.",
      "fév.",
      "mars",
      "avr",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc.",
    ];
  }

  if (!activeOption || !chart) return;

  const chartData = JSON.parse(chart.dataset.table);
  const activeChartData = chartData.find(
    (data) => data.structETF == activeOption
  ).data;
  if (!activeChartData) return;

  let dateLabels = [];
  for (let i = 0; i < activeChartData.date.length; i++) {
    const date = new Date(activeChartData.date[i]);
    date.setDate(date.getDate() + 1); // Add one day to the end date. Data shows last day, but the fund "closes" following day
    const dateDate = monthNames[date.getMonth()] + " " + date.getFullYear();
    if (endDateSpan && i + 1 == activeChartData.date.length) {
      if (document.documentElement.lang == "fr-CA") {
        endDateSpan.innerHTML =
          date.getDate() +
          " " +
          monthNames[date.getMonth()] +
          " " +
          date.getFullYear();
      } else {
        endDateSpan.innerHTML =
          monthNames[date.getMonth()] +
          " " +
          date.getDate() +
          ", " +
          date.getFullYear();
      }
    }
    if (dateLabels.includes(dateDate)) continue;
    dateLabels.push(dateDate);
  }

  /*
      Data order:
      [0] => Cap
      [1] => Buffer
      [2] => ETF Return
      [3] => Underlier Return
    */

  const labels = JSON.parse(chart.dataset.labels);

  const xData = [
    activeChartData.date,
    activeChartData.date,
    activeChartData.date,
    activeChartData.date,
  ];

  const yData = [
    activeChartData.cap,
    activeChartData.buffer,
    activeChartData.etfRet,
    activeChartData.undRet,
  ];

  const colors = [
    "rgba(179,179,179,1)",
    "rgba(128,128,128,1)",
    "rgba(230,108,55,1)",
    "rgba(107,0,123,1)",
  ];

  const lineSize = [2, 2, 3, 3];

  const lineDash = ["dot", "dot", "solid", "solid"];

  let data = [];

  for (let i = 0; i < xData.length; i++) {
    data.push({
      x: xData[i],
      y: yData[i],
      name: labels[i],
      type: "scatter",
      mode: "lines",
      hovertemplate:
        document.documentElement.lang == "fr-CA"
          ? "%{x|%e %B %Y}, %{y:.2%}"
          : "%{x|%B %e, %Y}, %{y:.2%}",
      line: {
        color: colors[i],
        width: lineSize[i],
        dash: lineDash[i],
      },
    });
  }

  return data;
};

structureOutcomesChartInit();
